import { computed, ref, watch } from 'vue';
import { MpCombinationsContext } from '@/components/mpRecommendation/MpCombinationsContext';
import { defineContext } from '@/core/lib/defineContext';
import type { IMpCombination, IMpRecommendationTicket } from '@/interface/IPopularMixParlay';

export const MpCombinationContext = defineContext('MpCombination', (mpCombination: IMpCombination) => {
    const combination = ref<Map<string, IMpRecommendationTicket>>(new Map());
    const isLoaded = computed(() => {
        const tickets = Array.from(combination.value.values());
        if (mpCombination.subBetKeys.length === 0 || tickets.length !== mpCombination.subBetKeys.length) {
            return false;
        }
        return tickets.every(x => x.event && x.odds && x.priceOption);
    });

    const { removeMpCombination: _removeMpCombination, updateMpCombinationLoaded } = MpCombinationsContext.inject();
    watch(isLoaded, () => {
        if (isLoaded.value) {
            updateMpCombinationLoaded(mpCombination.key);
        }
    }, { immediate: true });

    function updateSubBet(key: string, subBet: IMpRecommendationTicket) {
        combination.value.set(key, subBet);
    }

    function removeMpCombination() {
        _removeMpCombination(mpCombination.key);
    }

    return {
        combination,
        isLoaded,
        updateSubBet,
        removeMpCombination,
    };
});
